module.exports = __webpack_public_path__ + "static/media/sultron.53aef9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/climasense/cenicilla_manzano/preventiva/sultron.png
// module id = 1747
// module chunks = 3